module.exports = __webpack_public_path__ + "static/media/more.7f338562.svg";